export default "__VITE_ASSET__BEua6DHD__"